module.exports = __webpack_public_path__ + "static/media/disaster-risk-management.aeaa708d.png";